import { render } from "./Settle.vue?vue&type=template&id=2124a242"
import script from "./Settle.vue?vue&type=script&lang=js"
export * from "./Settle.vue?vue&type=script&lang=js"

import "./Settle.vue?vue&type=style&index=0&id=2124a242&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__